import { Grid, GridProps } from '@mui/material';
import React from 'react';

export const FormGridItem = (props: GridProps) => {
    return (
        <Grid item xs={12} sm={6} {...props} />
    );
}